export const SCRIPTS = {
  // TODO: This library enables the automatic resizing of the height and width of both same and
  // cross domain iFrames to fit their contained content. It provides a range of features
  // to address the most common issues with using iFrames. See for more detail:
  // https://confluence.int.abnamro.com/pages/viewpage.action?spaceKey=CROW&title=How-to%3A+iFrame+pages+on+the+open+domain
  iframeResizer:
    'https://slimwonen.abnamro.nl/iframeResizer.contentWindow-3.3.5.min.js',
};

export const SCROLL_WRAPPER_TYPES = {
  nav: 'nav',
  image: 'image',
};

export const DOMAINS = {
  staging: 'https://doorpakken.guideplatform.net',
  production: 'https://doorpakken.abnamro.nl',
  open: 'https://www.abnamro.nl',
};
